// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/deal_memo.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GetStaffResponse } from "./staff_pb";
import { file_api_proto_v1_staff } from "./staff_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/deal_memo.proto.
 */
export const file_api_proto_v1_deal_memo: GenFile = /*@__PURE__*/
  fileDesc("ChxhcGlfcHJvdG8vdjEvZGVhbF9tZW1vLnByb3RvEgxhcGlfcHJvdG8udjEiUAoVQ3JlYXRlRGVhbE1lbW9SZXF1ZXN0EgwKBG1lbW8YASABKAkSDwoHZGVhbF9pZBgCIAEoAxIYChBjb21wYW55X3N0YWZmX2lkGAMgASgDIjEKFVVwZGF0ZURlYWxNZW1vUmVxdWVzdBIKCgJpZBgBIAEoAxIMCgRtZW1vGAIgASgJIiMKFURlbGV0ZURlYWxNZW1vUmVxdWVzdBIKCgJpZBgBIAEoAyIpChZHZXREZWFsTWVtb0xpc3RSZXF1ZXN0Eg8KB2RlYWxfaWQYASABKAMiJgoYVG9nZ2xlUGluRGVhbE1lbW9SZXF1ZXN0EgoKAmlkGAEgASgDItMBChBEZWFsTWVtb1Jlc3BvbnNlEgoKAmlkGAEgASgDEgwKBG1lbW8YAiABKAkSDgoGcGlubmVkGAMgASgIEjUKEXJlZ2lzdHJhdGlvbl9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgthcHBfdXBkYXRlZBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLQoFc3RhZmYYBiABKAsyHi5hcGlfcHJvdG8udjEuR2V0U3RhZmZSZXNwb25zZSJIChdHZXREZWFsTWVtb0xpc3RSZXNwb25zZRItCgVtZW1vcxgBIAMoCzIeLmFwaV9wcm90by52MS5EZWFsTWVtb1Jlc3BvbnNlQjNaMWdpdGh1Yi5jb20vaC1zY2FwZS9pZXNhcHVyaS9nby9hcGlfcHJvdG8vdjE7YXBpdjFiBnByb3RvMw", [file_api_proto_v1_staff, file_google_protobuf_timestamp]);

/**
 * @generated from message api_proto.v1.CreateDealMemoRequest
 */
export type CreateDealMemoRequest = Message<"api_proto.v1.CreateDealMemoRequest"> & {
  /**
   * @generated from field: string memo = 1;
   */
  memo: string;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 company_staff_id = 3;
   */
  companyStaffId: bigint;
};

/**
 * Describes the message api_proto.v1.CreateDealMemoRequest.
 * Use `create(CreateDealMemoRequestSchema)` to create a new message.
 */
export const CreateDealMemoRequestSchema: GenMessage<CreateDealMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 0);

/**
 * @generated from message api_proto.v1.UpdateDealMemoRequest
 */
export type UpdateDealMemoRequest = Message<"api_proto.v1.UpdateDealMemoRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string memo = 2;
   */
  memo: string;
};

/**
 * Describes the message api_proto.v1.UpdateDealMemoRequest.
 * Use `create(UpdateDealMemoRequestSchema)` to create a new message.
 */
export const UpdateDealMemoRequestSchema: GenMessage<UpdateDealMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 1);

/**
 * @generated from message api_proto.v1.DeleteDealMemoRequest
 */
export type DeleteDealMemoRequest = Message<"api_proto.v1.DeleteDealMemoRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteDealMemoRequest.
 * Use `create(DeleteDealMemoRequestSchema)` to create a new message.
 */
export const DeleteDealMemoRequestSchema: GenMessage<DeleteDealMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 2);

/**
 * @generated from message api_proto.v1.GetDealMemoListRequest
 */
export type GetDealMemoListRequest = Message<"api_proto.v1.GetDealMemoListRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.GetDealMemoListRequest.
 * Use `create(GetDealMemoListRequestSchema)` to create a new message.
 */
export const GetDealMemoListRequestSchema: GenMessage<GetDealMemoListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 3);

/**
 * @generated from message api_proto.v1.TogglePinDealMemoRequest
 */
export type TogglePinDealMemoRequest = Message<"api_proto.v1.TogglePinDealMemoRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.TogglePinDealMemoRequest.
 * Use `create(TogglePinDealMemoRequestSchema)` to create a new message.
 */
export const TogglePinDealMemoRequestSchema: GenMessage<TogglePinDealMemoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 4);

/**
 * @generated from message api_proto.v1.DealMemoResponse
 */
export type DealMemoResponse = Message<"api_proto.v1.DealMemoResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string memo = 2;
   */
  memo: string;

  /**
   * @generated from field: bool pinned = 3;
   */
  pinned: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp registration_date = 4;
   */
  registrationDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp app_updated = 5;
   */
  appUpdated?: Timestamp;

  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 6;
   */
  staff?: GetStaffResponse;
};

/**
 * Describes the message api_proto.v1.DealMemoResponse.
 * Use `create(DealMemoResponseSchema)` to create a new message.
 */
export const DealMemoResponseSchema: GenMessage<DealMemoResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 5);

/**
 * @generated from message api_proto.v1.GetDealMemoListResponse
 */
export type GetDealMemoListResponse = Message<"api_proto.v1.GetDealMemoListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.DealMemoResponse memos = 1;
   */
  memos: DealMemoResponse[];
};

/**
 * Describes the message api_proto.v1.GetDealMemoListResponse.
 * Use `create(GetDealMemoListResponseSchema)` to create a new message.
 */
export const GetDealMemoListResponseSchema: GenMessage<GetDealMemoListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_deal_memo, 6);

